// UI visibility only; API access is unchanged. More Solutions, the
// onboarding pages and the dashboard "View Info" items follow the company
// setting hideMoreSolutions (a missing value reads as shown).
export const getUiFeatures = ({ user } = {}) => ({
  moreSolutionsEnabled: user?.hideMoreSolutions !== true,
});
